import { zAttrLabelsAttributes } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelsData";
import { zPersonEntity } from "src/types/ZPersonEntity";
import { z } from "zod";

export const zPersonSearchData = z.object({
  content: zPersonEntity.array(),
  totalElements: z.number(),
  attributesLabels: zAttrLabelsAttributes.optional(),
});
